// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"153":"analytics","539":"achievements","954":"achievements-ui"}[chunkId] || chunkId) + "." + {"8":"49b6321b","56":"aac6c800","153":"3974a84d","188":"288f935d","397":"fdfea7ab","539":"f0a9f837","954":"3db4e553","989":"80e348ea"}[chunkId] + ".chunk.js";
};